import { Controller } from "stimulus";
import { Toast } from "bootstrap";

export default class ToastController extends Controller {
  initialize() {
    let toastElList = [].slice.call(document.querySelectorAll('.toast'))
    let toastList = toastElList.map(function (toastEl) {
      return new Toast(toastEl, {delay: 10000});
    })
    toastList.forEach(toast => {
      toast.show();
    });
  }
}
